module.exports = __webpack_public_path__ + "static/media/a4_02.bc199112.jpg";